// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App";

const dotenv = require('dotenv');
const config = dotenv.config()

if (config.error) {
    // console.log('Could not load env file', config.error)
}
// router setup
import routes from "./routes/routes";

// Plugins
import GlobalComponents from "./globalComponents";
import GlobalDirectives from "./globalDirectives";

// MaterialDashboard plugin
import MaterialDashboard from "./material-dashboard";

import Chartist from "chartist";
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueApexCharts from 'vue-apexcharts'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { dom } from '@fortawesome/fontawesome-svg-core'

import { fas } from '@fortawesome/free-solid-svg-icons'

library.add(fas)


import Vuelidate from 'vuelidate';
import VueTheMask from 'vue-the-mask'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify, {
    theme: {
        primary: '#2b5577'
    }
});

import moment from 'moment'
import VeeValidate from 'vee-validate';
import VueSessionStorage from 'vue-sessionstorage'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import './registerServiceWorker'
import { VueHammer } from 'vue2-hammer'
import VueGeolocation from 'vue-browser-geolocation';
import Notifications from 'vue-notification'
import Clipboard from 'v-clipboard'
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
import store from '@/store'

const socket = io(process.env.VUE_APP_API_URL, {
    'reconnection': true,
    'reconnectionDelay': 500,
    'reconnectionAttempts': 10
});

Vue.use(VueSocketIOExt, socket);


Vue.use(Clipboard)
Vue.use(VueGeolocation);
Vue.use(VueAxios, axios)

Vue.use(VueHammer)
const datepickerOptions = {
    days: ['Segunda-feira', 'Terça', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado', 'Domingo'],
    daysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom'],
    monthNames: [
        'Janeiro',
        'Fevereiro',
        'Março',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro',
    ],
    colors: {
        selected: '#2A5377',
        inRange: '#88C658',
        selectedText: '#fff',
        text: '#565a5c',
        inRangeBorder: '#ebca9d',
        disabled: '#fff',
        hoveredInRange: '#ebca9d'
    },
    texts: {
        apply: 'Aplicar',
        cancel: 'Cancelar',
        keyboardShortcuts: 'Atalhos',
    },
}
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

dom.watch()
Vue.use(VueSessionStorage)
Vue.use(VeeValidate);
Vue.use(VueTheMask)
Vue.use(Vuelidate)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('apexchart', VueApexCharts)


Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyC0x-fKDpBgy6ldxYgHyJD_gFuGos-1CxE',
        libraries: 'places, visualization',
        region: 'PT-BR',
        language: 'pt-br',
    },
});


Vue.filter('formatDate', function(value) {
    if (value) {
        var time = moment.duration("03:00:00");
        var date = moment(String(value)).subtract(time).format('DD/MM/YYYY HH:mm')
        return date;
    }
});
Vue.filter('formatDateNH', function(value) {
    if (value) {
        var time = moment.duration("03:00:00");
        var date = moment(String(value)).subtract(time).format('DD/MM/YYYY')
        return date;
    }
});
Vue.filter('formatDateNormal', function(value) {
    if (value) {
        var date = moment(String(value)).format('DD/MM/YYYY HH:mm')
        return date;
    }
});
Vue.filter('formatDateNormalSH', function(value) {
    if (value) {
        var date = moment(String(value)).format('DD/MM/YYYY')
        return date;
    }
});
Vue.filter('formatTimeNormal', function(value) {
    if (value) {
        var date = moment(String(value)).format('HH:mm')
        return date;
    }
});

// configure router
const router = new VueRouter({
    mode: 'history',
    routes, // short for routes: routes
    linkExactActiveClass: "nav-item active"
});


router.beforeEach((to, from, next) => {
    if (localStorage.getItem('token')) {
        next();
    } else {
        if ((to.name != 'Login') && (to.name != 'Teste')) {
            next({ name: 'Login' })
        } else {
            next();
        }

    }
});

Vue.prototype.$Chartist = Chartist;


Vue.use(VueRouter);
Vue.use(MaterialDashboard);
Vue.use(GlobalComponents);
Vue.use(GlobalDirectives);
Vue.use(Notifications);



/* eslint-disable no-new */
Vue.config.ignoredElements = ['md-app-drawer', 'mdappdrawer', 'drawer']
Vue.config.productionTip = false

new Vue({
    el: "#app",
    render: h => h(App),
    router,
    store,
    data: {
        Chartist: Chartist
    },
});

Array.prototype.remove = function() {
    var what, a = arguments,
        L = a.length,
        ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};

if (process.env.NODE_ENV == 'production') {
    console.error = () => {}
    console.log = () => {}
    console.warn = () => {}
    console.info = () => {}
    Vuetify.consoleWarn = () => {}
    Vuetify.consoleInfo = () => {}
}